// extracted by mini-css-extract-plugin
export var skeleton = "styles-module--skeleton--R0DvO";
export var shimmer = "styles-module--shimmer--sbjj3";